import { api } from "./client";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://api.vienna.local";

export const AdvertisementAPI = {
  // ── Admin (authenticated) ─────────────────────────────────────────────────

  createSession: async (payload) => {
    const { data } = await api.post("/api/v1/advertisements/sessions", payload);
    return data;
  },

  // Note: GET /sessions and GET /submissions not yet in spec — kept as placeholders
  getSessions: async (status) => {
    const params = status ? { status } : {};
    const { data } = await api.get("/api/v1/advertisements/sessions-list", { params });
    return data;
  },

  deleteSession: async (id) => {
    await api.delete(`/api/v1/advertisements/sessions/${id}`);
    return true;
  },

  getSubmissions: async () => {
    const { data } = await api.get("/api/v1/advertisements/submissions-list");
    return data;
  },

  // ── Advertisements ────────────────────────────────────────────────────────
  getAdvertisements: async (status) => {
    const params = status ? { status } : {};
    const { data } = await api.get("/api/v1/advertisements", { params });
    return data;
  },

  updateAdvertisement: async (id, payload) => {
    const { data } = await api.patch(`/api/v1/advertisements/${id}`, payload);
    return data;
  },

  updateAdvertisementStatus: async (id, status) => {
    const { data } = await api.patch(`/api/v1/advertisements/${id}/status`, { status });
    return data;
  },

  deleteAdvertisement: async (id) => {
    await api.delete(`/api/v1/advertisements/${id}`);
    return true;
  },

  getReport: async (id) => {
    const { data } = await api.get(`/api/v1/advertisements/${id}/report`);
    return data;
  },

  /** What billing this campaign would produce, worked out by the server. */
  previewInvoice: async (id, netAmountCents) => {
    const { data } = await api.get(`/api/v1/advertisements/${id}/invoice/preview`, {
      params: netAmountCents == null ? {} : { netAmountCents },
    });
    return data;
  },

  /**
   * Raises the invoice on the server and mails it to the advertiser.
   * netAmountCents may be null to bill the price pinned when the package was booked.
   */
  sendInvoice: async (id, netAmountCents) => {
    const { data } = await api.post(`/api/v1/advertisements/${id}/invoice`, { netAmountCents });
    return data;
  },

  createReportLink: async (id) => {
    const { data } = await api.post(`/api/v1/advertisements/${id}/report-link`);
    return data;
  },

  getPublicReport: async (token) => {
    const { data } = await axios.get(`${BASE_URL}/api/v1/advertisements/reports/public/${token}`);
    return data;
  },

  getPublicReportBySession: async (token) => {
    const { data } = await axios.get(`${BASE_URL}/api/v1/advertisements/public/${token}/report`);
    return data;
  },

  getPublicAdvertisementStatus: async (token) => {
    const { data } = await axios.get(`${BASE_URL}/api/v1/advertisements/reports/public/${token}/status`);
    return data;
  },

  uploadAdminAsset: async (id, file, language) => {
    const fd = new FormData();
    fd.append("file", file);
    const { data } = await api.post(`/api/v1/advertisements/${id}/assets?language=${language}`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  },

  // ── Public (no auth) ──────────────────────────────────────────────────────

  getPublicSession: async (token) => {
    const { data } = await axios.get(`${BASE_URL}/api/v1/advertisements/public/${token}`);
    return data;
  },

  // Step 1: upload one image, get back { id, fileUrl, ... }
  uploadAsset: async (token, file, language) => {
    const fd = new FormData();
    fd.append("file", file);
    const { data } = await axios.post(
      `${BASE_URL}/api/v1/advertisements/public/${token}/assets?language=${language}`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return data; // { id, language, fileUrl, ... }
  },

  // Step 2: submit JSON with assetIds + billing fields
  submitAd: async (token, payload) => {
    const { data } = await axios.post(
      `${BASE_URL}/api/v1/advertisements/public/${token}/submit`,
      payload,
      { headers: { "Content-Type": "application/json" } }
    );
    return data; // { submissionId }
  },
};
